import { ITags } from "api/interfaces/get-page-details/product-page.type";
import { PRODUCT_PAGE_TYPES } from "util/product/product-constants";
import { useSelector } from "react-redux";
import { RootState } from "interfaces/generics.type";
import RenderTag from "./RenderTag";

interface IProps {
  productTags: ITags[],
  className?: string
}

function ProductTags(props: IProps) {
  const { productTags, className = "" } = props;
  const currentPageType = useSelector((state: RootState) => state.utils.currentPageType);

  return (
    <div className={`d-flex flex-wrap ${className}`}>
      {productTags.map((tag, index: number) => {
        let tagValue = tag.uiDetails ? tag.uiDetails.content.value : "NA";
        const desc = tag.uiDetails ? tag.uiDetails.content.description : "NA";
        if (PRODUCT_PAGE_TYPES.includes(currentPageType) && tagValue !== "NA") {
          tagValue += " Grade";
        }
        return (
          <RenderTag
            key={index}
            {...{ desc, tagValue }}
          />
        );
      })}
    </div>
  );
}

export default ProductTags;
